import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import AlarmIcon from "@mui/icons-material/Alarm";
import moment from "moment";
import 'rc-time-picker/assets/index.css';
import './timeInput.css'
import { Dropdown } from "react-bootstrap";
import toast from "react-hot-toast";

const TimePickerInput = ({ handleFormatted, selectedDateInput, tripType }) => {
    const [intervals, setIntervals] = useState([]);
    const [dropdownStatus, setDropdownStatus] = useState(false);
    const [timeValue, setTimeValue] = useState('');
    const dropdownRef = useRef(null);

    // Use ref for localStorage data to prevent unnecessary re-renders
    const dbDataRef = useRef(JSON.parse(localStorage.getItem('cab_listing')) || {});

    const format = "h:mm A";

    useEffect(() => {
        // Update ref when localStorage changes
        dbDataRef.current = JSON.parse(localStorage.getItem('cab_listing')) || {};
        generateTimeIntervals(selectedDateInput);
    }, [selectedDateInput]);

    useEffect(() => {
        // Handle time initialization logic
        const dbData = dbDataRef.current;
        const selectedDate = moment(selectedDateInput).startOf('day');
        const dbPickupDate = moment(dbData.pickup_date || '').startOf('day');
        
        if (dbData.trip_type === tripType && selectedDate.isSame(dbPickupDate)) {
            if (dbData.pickup_time) {
                setTimeValue(dbData.pickup_time);
            } else {
                const firstTime = intervals[0];
                if (firstTime) {
                    setTimeValue(firstTime);
                    handleFormatted({ 'pickup_time': firstTime });
                }
            }
        } else {
            const firstTime = intervals[0];
            if (firstTime) {
                setTimeValue(firstTime);
                handleFormatted({ 'pickup_time': firstTime });
            }
        }
    }, [intervals, selectedDateInput, tripType]);

    const generateTimeIntervals = (pickupDate) => {
        let arrays = [];
        let startTime;
        const endTime = moment().endOf('day');
        
        if (moment(pickupDate).isSame(moment(), 'day')) {
            startTime = moment().add(130, 'minutes');
        } else {
            startTime = moment().startOf('day');
        }
        
        while (startTime.isBefore(endTime)) {
            arrays.push(startTime.format(format));
            startTime.add(30, 'minutes');
        }
        
        setIntervals(arrays);
        return arrays;
    };

    const handleTimeChange = (time, date) => {
        // Validate time format
        if (!moment(time, format, true).isValid()) {
            return;
        }

        const formattedTime = time;
        const selectedDate = moment(date);
        const currentTime = moment();
        const isToday = selectedDate.isSame(currentTime, 'day');

        // Time validation logic
        if (isToday) {
            const minAllowedTime = moment(currentTime).add(50, 'minutes');
            const selectedMomentTime = moment(formattedTime, format);
            
            if (selectedMomentTime.isBefore(minAllowedTime)) {
                toast.error('Please select a time at least 2 hours from now');
                return;
            }
        }

        // Update state and notify parent
        setTimeValue(formattedTime);
        handleFormatted({ 'pickup_time': formattedTime });
    };

    const handleSuggestionClick = (value) => {
        setTimeValue(value);
        handleFormatted({ 'pickup_time': value });
        setDropdownStatus(false);
    };

    // Handle clicks outside dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownStatus(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <Form.Group className="w15 position-relative" controlId="timePicker">
            <Form.Label>Time</Form.Label>
            <AlarmIcon />
            <input 
                className="custome_input_css" 
                type="text" 
                value={timeValue} 
                onChange={(e) => handleTimeChange(e.target.value, selectedDateInput)} 
                placeholder="Select time" 
                onFocus={() => {
                    setDropdownStatus(true);
                    generateTimeIntervals(selectedDateInput);
                }}
            />
            {dropdownStatus && intervals.length > 0 && (
                <div ref={dropdownRef}>
                    <Dropdown className="w-100 position-absolute drpdwnspc suggetionsDropDown" style={{height:'200px'}}>
                        {intervals.map((value, index) => (
                            <Dropdown.Item 
                                key={index} 
                                onClick={() => handleSuggestionClick(value)}
                                onMouseDown={(e) => e.preventDefault()} // Prevent blur
                            >
                                {value}
                            </Dropdown.Item>
                        ))}
                    </Dropdown>
                </div>
            )}
        </Form.Group>
    );
};

export default TimePickerInput;